import React, { useEffect, useState } from "react";
import styles from "./auth0-header.module.css";
import { Header } from "@hub/ui/auth0/developers-components/src/index";

enum MESSAGE_BAR_STATE {
  CLOSED = "CLOSED",
  OPEN = "OPEN",
}

enum MESSAGE_BAR_STATUS {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

const messageBar = {
  status: MESSAGE_BAR_STATUS.INACTIVE,
  state: {
    key: "messageBar_state",
  },
};

export const Auth0Header: React.FC = () => {
  const [isMessageBarVisible, setIsMessageBarVisible] = useState(false);

  useEffect(() => {
    const isMessageBarActive = messageBar.status === MESSAGE_BAR_STATUS.ACTIVE;

    if (!isMessageBarActive) {
      setIsMessageBarVisible(false);

      return;
    }

    let messageBarState = window.localStorage.getItem(messageBar.state.key);

    if (!messageBarState) {
      setIsMessageBarVisible(false);

      return;
    }

    if (messageBarState === MESSAGE_BAR_STATE.CLOSED) {
      setIsMessageBarVisible(false);

      return;
    }

    setIsMessageBarVisible(true);

    const closeButton = document.querySelector("header button");

    if (closeButton) {
      closeButton.addEventListener("click", () => {
        setIsMessageBarVisible(false);
      });
    }
  }, []);

  return (
    <>
      <div
        className={styles.ad__isMobile}
        style={{
          visibility: isMessageBarVisible ? "visible" : "hidden",
          height: isMessageBarVisible ? "6rem" : "0",
          transition: "all 0.4s linear",
        }}
      />
      <div
        className={styles.ad__isDesktop}
        style={{
          visibility: isMessageBarVisible ? "visible" : "hidden",
          height: isMessageBarVisible ? "4.8rem" : "0",
          transition: "all 0.4s linear",
        }}
      />
      <div className={styles.auth0Header}>
        <Header dark={false} />
      </div>
    </>
  );
};
